{
    "common": {
        "languageSelector": "Idioma"
    },
    "navbar": {
        "howItWorks": "Cómo funciona",
        "features": "Funciones",
        "pricing": "Precios",
        "dashboard": "Panel",
        "logout": "Cerrar sesión",
        "login": "Iniciar sesión",
        "createAccount": "Crear cuenta",
        "myAccount": "Mi cuenta",
        "toggleMenu": "Abrir menú"
    },
    "auth": {
        "brandName": "HireFit",
        "footerTagline": "Sin spam. Sin relleno. Solo resultados.",
        "brandPanel": {
            "headline": "Hacemos que tu perfil sea imposible de ignorar.",
            "tagline": "Conseguí el trabajo de tus sueños con confianza",
            "body": "Coaching con IA, análisis de CV y preparación para entrevistas. ¡Todo en un solo lugar!",
            "resumeHint": "¡Este podría ser tu CV!"
        },
        "google": {
            "notConfigured": "El inicio de sesión con Google todavía no está disponible en este entorno.",
            "scriptError": "No pudimos cargar el inicio de sesión con Google. Revisá tu conexión e intentá de nuevo.",
            "dismissed": "Cancelaste el inicio de sesión con Google.",
            "submitFallback": "No pudimos iniciar sesión con Google. Intentá de nuevo."
        },
        "login": {
            "title": "¿Listo para tu próxima oferta?",
            "subtitle": "Iniciá sesión en tu cuenta de HireFit",
            "googleButton": "Continuar con Google",
            "divider": "o iniciá sesión con tu email",
            "emailLabel": "Correo electrónico",
            "emailPlaceholder": "ejemplo@gmail.com",
            "passwordLabel": "Contraseña",
            "passwordPlaceholder": "Ingresá tu contraseña",
            "forgotPassword": "¿Olvidaste tu contraseña?",
            "showPassword": "Mostrar contraseña",
            "hidePassword": "Ocultar contraseña",
            "submitDefault": "Iniciar sesión",
            "submitLoading": "Iniciando sesión...",
            "noAccount": "¿No tenés una cuenta?",
            "createAccountLink": "Crear cuenta",
            "notices": {
                "emailChanged": "Tu email cambió. Iniciá sesión de nuevo.",
                "accountDeleted": "Tu cuenta fue eliminada."
            },
            "errors": {
                "emailRequired": "El email es obligatorio.",
                "emailInvalid": "Ingresá un email válido.",
                "passwordRequired": "La contraseña es obligatoria.",
                "passwordTooShort": "La contraseña debe tener al menos 6 caracteres.",
                "submitFallback": "No se pudo iniciar sesión. Revisá tus credenciales."
            }
        },
        "register": {
            "title": "¿Listo para tu próxima oferta?",
            "subtitle": "Creá tu cuenta de HireFit",
            "googleButton": "Continuar con Google",
            "divider": "o registrate con tu email",
            "firstNameLabel": "Nombre",
            "lastNameLabel": "Apellido",
            "emailLabel": "Correo electrónico",
            "emailPlaceholder": "ejemplo@gmail.com",
            "passwordLabel": "Contraseña",
            "passwordPlaceholder": "Mínimo 8 caracteres",
            "showPassword": "Mostrar contraseña",
            "hidePassword": "Ocultar contraseña",
            "submitDefault": "Crear cuenta",
            "submitLoading": "Creando cuenta...",
            "haveAccount": "¿Ya tenés una cuenta?",
            "signInLink": "Iniciar sesión",
            "errors": {
                "firstNameRequired": "El nombre es obligatorio.",
                "lastNameRequired": "El apellido es obligatorio.",
                "emailRequired": "El email es obligatorio.",
                "emailInvalid": "Ingresá un email válido.",
                "passwordRequired": "La contraseña es obligatoria.",
                "passwordTooShort": "La contraseña debe tener al menos 8 caracteres.",
                "submitFallback": "No se pudo crear la cuenta en este momento."
            }
        }
    },
    "dashboard": {
        "shell": {
            "sidebar": {
                "mainNavigation": "Navegación principal",
                "dashboard": "Panel",
                "myCvs": "Mis CV",
                "myAnalysis": "Mi análisis",
                "jobDescriptions": "Descripciones de puesto",
                "sevenDayPlan": "Plan de 7 días",
                "voiceNotes": "Notas de voz",
                "cvRewrite": "Análisis completo",
                "realityCheck": "Reality Check",
                "jobMatches": "Coincidencias de empleo",
                "jobTracker": "Seguimiento de postulaciones",
                "interviewPrep": "Preparación de entrevistas",
                "outreach": "Outreach",
                "linkedin": "LinkedIn",
                "settings": "Configuración",
                "billing": "Facturación",
                "signOut": "Cerrar sesión",
                "currentPlanLabel": "TU PLAN ACTUAL ES",
                "wantMore": "¿QUERÉS MÁS?",
                "updateNow": "¡ACTUALIZÁ AHORA!",
                "planAriaLabel": "Plan actual: {{plan}}. Ir a facturación",
                "lockedAriaLabel": "{{feature}} requiere {{tier}}. Ir a facturación para mejorar el plan"
            },
            "header": {
                "greeting": "¡Hola, {{name}}!",
                "subtitle": "Vamos a conseguirte ese trabajo.",
                "toggleNavAriaLabel": "Mostrar u ocultar el menú de navegación",
                "profileMenuAriaLabel": "Menú de perfil de {{name}}",
                "adminPanel": "Panel de administración",
                "myProfile": "Mi perfil",
                "logout": "Cerrar sesión"
            },
            "newCvModal": {
                "ariaLabel": "Subir un nuevo CV",
                "title": "Nuevo CV",
                "subtitle": "Subí un PDF o DOCX — la IA lo va a analizar y calcular su puntaje ATS.",
                "closeAriaLabel": "Cerrar",
                "dropzoneAriaLabel": "Zona de carga: arrastrá un PDF o DOCX acá",
                "dropzoneText": "Arrastrá tu CV acá",
                "browseFiles": "Buscar archivos",
                "formatsHint": "PDF o DOCX · máx. 10 MB",
                "removeFile": "Quitar archivo",
                "uploading": "Subiendo…",
                "analyzing": "Analizando tu CV…",
                "analyzeCta": "Analizar mi CV",
                "errors": {
                    "invalidType": "Solo se admiten archivos PDF y DOCX.",
                    "tooLarge": "El archivo supera el límite de 10 MB ({{size}}).",
                    "unsupportedType": "El servidor no acepta este tipo de archivo.",
                    "tooLargeServer": "El archivo es demasiado grande para el servidor.",
                    "sessionExpired": "Tu sesión expiró. Iniciá sesión de nuevo.",
                    "uploadFailed": "No se pudo subir el archivo. Intentá de nuevo.",
                    "analysisQuotaExhausted": "Usaste todos los análisis de CV de este período. Mejorá el plan o esperá al siguiente período.",
                    "analysisFailed": "El análisis falló. Probá con otro archivo.",
                    "pollFailed": "No se pudo consultar el estado del análisis. Actualizá la página."
                }
            },
            "heroCard": {
                "ariaLabel": "Resultado más reciente del CV",
                "label": "TU RESULTADO MÁS RECIENTE",
                "heading": "Tu CV optimizado está listo",
                "headingClean": "Se ve genial — sin errores críticos",
                "subtitle": "Encontramos errores críticos que están bloqueando tus entrevistas.",
                "subtitleErrorSingular": "Encontramos {{count}} error crítico que está bloqueando tus entrevistas.",
                "subtitleErrorPlural": "Encontramos {{count}} errores críticos que están bloqueando tus entrevistas.",
                "subtitleClean": "¡Felicidades! No hay errores críticos bloqueando tus entrevistas.",
                "subtitlePreview": "Tu vista previa del análisis está lista. Abre Análisis completo para el panorama entero.",
                "viewCv": "Ver mi CV",
                "fullAnalysis": "Análisis completo"
            },
            "footer": {
                "product": "Producto",
                "productFeatures": "Funciones",
                "productPricing": "Precios",
                "productHowItWorks": "Cómo funciona",
                "company": "Empresa",
                "companyAbout": "Nosotros",
                "companyBlog": "Blog",
                "companyCareers": "Empleo",
                "support": "Soporte",
                "supportHelpCenter": "Centro de ayuda",
                "supportContact": "Contacto",
                "supportPrivacy": "Privacidad",
                "copyright": "© 2026 HireFit. Todos los derechos reservados."
            }
        },
        "cvDetail": {
            "ariaLabel": "Mis CV",
            "title": "Mis CV",
            "subtitle": "Tu puntaje, versiones optimizadas y encaje por rol.",
            "loadingAriaLabel": "Cargando detalle del CV",
            "emptyTitle": "Subí tu primer CV",
            "emptyHint": "Agregá un PDF o DOCX para ver tu puntaje ATS y matches de rol.",
            "processingHint": "Estamos analizando tu CV. Suele tardar un minuto.",
            "failedHint": "No pudimos analizar tu CV. Intentá subirlo de nuevo.",
            "uploadLimitReached": "Alcanzaste el límite de carga de CVs de tu plan.",
            "uploadAnalysis": {
                "title": "Tu CV",
                "file": "Archivo",
                "role": "Rol detectado"
            },
            "yourScore": "Tu puntaje",
            "scoreAriaLabel": "Puntaje de tu CV",
            "scoreBlurb": "¡Buen trabajo! Tu CV está bien optimizado y alineado con las mejores prácticas",
            "optimizedScoreLabel": "Optimizado",
            "originalScoreLabel": "Original",
            "optimizedScoreAriaLabel": "Puntaje del CV optimizado",
            "originalScoreAriaLabel": "Puntaje original del primer análisis",
            "dropzone": {
                "ariaLabel": "Zona de carga: arrastrá un PDF o DOCX acá",
                "title": "Soltá tu CV acá",
                "hint": "Subí tu CV (PDF o DOCX) para empezar el análisis",
                "cta": "Elegir archivo",
                "formats": "PDF o DOCX — Máx. 10MB",
                "uploading": "Subiendo tu CV…",
                "analyzing": "Analizando tu CV…",
                "replaceAriaLabel": "Zona de carga: arrastrá un PDF o DOCX para reemplazar tu CV actual",
                "replaceTitle": "Reemplazá tu CV",
                "replaceHint": "Podés subir otro, pero al hacerlo se sobrescribe el análisis actual.",
                "replaceCta": "Reemplazar archivo"
            },
            "matchedRequirements": "Requisitos cumplidos",
            "missingRequirements": "Requisitos faltantes",
            "noMatchedRequirements": "No hay requisitos cumplidos listados.",
            "noMissingRequirements": "No hay requisitos faltantes listados.",
            "downloadWithObservations": "Descargar CV con observaciones",
            "jdForm": {
                "title": "Descripción del puesto",
                "hint": "Contanos sobre el puesto al que estás aplicando. Vamos a comparar los requisitos con tu CV e identificar las keywords, skills y experiencia que deberías destacar.",
                "step1Title": "1. Ajustá tu CV al puesto",
                "step1Hint": "¿A qué puesto estás aplicando?",
                "step1Example": "ej. Customer Success Specialist",
                "step2Title": "2. Ajustá tu CV al puesto",
                "step2Hint": "Pegá acá la descripción del puesto. Incluí las responsabilidades, requisitos y calificaciones siempre que sea posible.",
                "titleLabel": "Título del rol",
                "titlePlaceholder": "Ingresá el título del puesto",
                "rawLabel": "Texto de la descripción",
                "rawPlaceholder": "Pegá acá la descripción del puesto…",
                "submit": "Analizar mi match",
                "success": "Descripción agregada. La decodificación puede demorar un momento.",
                "decoded": "Descripción lista — ya podés correr un análisis completo.",
                "selectForRewrite": "Usar para el análisis completo",
                "selectPlaceholder": "Elegí una descripción lista",
                "runRewrite": "Correr análisis completo",
                "rewriteLocked": "Pasate a Core o superior para correr un análisis completo.",
                "jdCreateLocked": "Pasate a Core, Pro o Premium para crear descripciones de puesto.",
                "jdPerCvLimit": "Tu plan incluye 1 descripción de puesto por CV.",
                "analysisTitle": "Análisis de la descripción de puesto",
                "decoding": "Decodificando esta descripción de puesto…",
                "seniority": "Seniority",
                "location": "Ubicación",
                "employment": "Tipo de empleo",
                "requiredSkills": "Habilidades requeridas",
                "responsibilities": "Responsabilidades",
                "optimizeQuotaExhausted": "Usaste todos los análisis completos de este período. Mejorá el plan o esperá al siguiente período.",
                "rewritePending": "El análisis completo sigue en curso. Podés salir de esta página — va a continuar.",
                "rewriteCompleted": "El análisis completo terminó. Podés descargarlo en Mi análisis.",
                "rewriteStartedTitle": "Análisis completo iniciado",
                "rewriteStartedBody": "Esto puede tardar unos minutos. Podés salir de esta página — seguimos trabajando.",
                "rewriteStartedDismiss": "Entendido",
                "status": {
                    "pending": "Pendiente",
                    "processing": "Decodificando…",
                    "parsed": "Lista",
                    "failed": "Falló"
                },
                "errors": {
                    "createFailed": "No se pudo crear la descripción. Intentá de nuevo.",
                    "decodeFailed": "No se pudo decodificar la descripción. Intentá de nuevo.",
                    "rewriteFailed": "No se pudo completar el análisis. Intentá de nuevo.",
                    "timeout": "El análisis completo está tardando más de lo esperado. Actualizá Mis CV en unos minutos para ver si terminó."
                },
                "voiceNotesRequired": "Generá y respondé las notas de voz de este CV antes de correr un análisis completo. Tus respuestas alimentan el CV optimizado.",
                "voiceNotesIncomplete": "Respondé todas las notas de voz de este CV antes de correr un análisis completo. Tus respuestas alimentan el CV optimizado.",
                "voiceNotesGateLink": "Ir a Notas de voz"
            },
            "resumeStatus": {
                "pending": "Pendiente",
                "processing": "Procesando…",
                "analyzed": "Analizado",
                "failed": "Falló"
            },
            "matchStatus": {
                "pending": "Pendiente",
                "processing": "Matcheando…",
                "completed": "Match",
                "failed": "Falló"
            },
            "errors": {
                "loadFailed": "No se pudo cargar el detalle de tu CV. Actualizá la página.",
                "downloadFailed": "La descarga falló. Intentá de nuevo."
            },
            "voiceNotes": {
                "title": "Notas de voz",
                "hint": "Generá preguntas de seguimiento a partir del análisis de tu CV y de la descripción del puesto, y respondélas por voz.",
                "generateCta": "Generar preguntas de voz",
                "generated": "{{count}} pregunta(s) de voz listas para este CV.",
                "upsell": "Las notas de voz empiezan en Core (hasta {{core}} preguntas). Pro incluye hasta {{pro}} notas guiadas. Premium incluye hasta {{premium}} preguntas.",
                "jdRequired": "Agregá una descripción de puesto para este CV antes de generar las notas de voz.",
                "upgradeCta": "Mejorá tu plan para desbloquear notas de voz",
                "limitHint": "Tu plan permite hasta {{limit}} pregunta(s) de voz por CV.",
                "errors": {
                    "generateFailed": "No se pudieron generar las preguntas de voz. Intentá de nuevo.",
                    "tierRequired": "Las notas de voz requieren Core o superior. Mejorá tu plan para continuar."
                }
            }
        },
        "jdSection": {
            "ariaLabel": "Descripción de puesto",
            "title": "Descripciones de puesto",
            "createLocked": "Pasate a Core, Pro o Premium para crear descripciones de puesto.",
            "jdPerCvLimit": "Tu plan incluye 1 descripción de puesto por CV.",
            "selectCvRequired": "Seleccioná un CV antes de agregar una descripción de puesto.",
            "cvFieldLabel": "CV",
            "selectCvOption": "Seleccioná un CV",
            "subtitle": "Pegá o subí un puesto para un CV específico — la IA va a decodificar los requisitos para hacer el match.",
            "newJdLabel": "NUEVA DESCRIPCIÓN DE PUESTO",
            "inputMethodAriaLabel": "Método de carga",
            "tabPasteText": "Pegar texto",
            "tabUploadFile": "Subir archivo",
            "titleFieldLabel": "Título",
            "titlePlaceholder": "ej. Senior Backend Engineer",
            "companyFieldLabel": "Empresa",
            "companyPlaceholder": "Opcional",
            "jdFieldLabel": "Descripción del puesto",
            "jdTextareaPlaceholder": "Pegá acá la publicación completa del puesto…",
            "dropzoneAriaLabel": "Zona de carga: arrastrá un PDF o DOCX acá",
            "dropzoneText": "Arrastrá la descripción del puesto acá",
            "browseFiles": "Buscar archivos",
            "formatsHint": "PDF o DOCX · máx. 10 MB",
            "removeFile": "Quitar archivo",
            "saving": "Guardando…",
            "decodeCta": "Decodificar descripción de puesto",
            "yourRolesLabel": "TUS PUESTOS",
            "loadingListAriaLabel": "Cargando descripciones de puesto",
            "emptyTitle": "Todavía no hay descripciones de puesto.",
            "emptyHint": "Agregá tu primer puesto para desbloquear el análisis de CV según el puesto.",
            "statusAriaLabel": "Estado: {{status}}",
            "status": {
                "pending": "Pendiente",
                "processing": "Decodificando…",
                "parsed": "Decodificado",
                "failed": "Falló"
            },
            "errors": {
                "resumeRequired": "Seleccioná un CV antes de enviar una descripción de puesto.",
                "titleRequired": "El título es obligatorio.",
                "textRequired": "Pegá el texto de la descripción antes de enviar.",
                "fileRequired": "Seleccioná un PDF o DOCX antes de enviar.",
                "invalidType": "Solo se admiten archivos PDF y DOCX.",
                "tooLarge": "El archivo supera el límite de 10 MB ({{size}}).",
                "loadFailed": "No se pudieron cargar tus descripciones de puesto. Actualizá la página.",
                "badRequest": "Revisá el título y el contenido, y probá de nuevo.",
                "unsupportedType": "El servidor no acepta este tipo de archivo.",
                "tooLargeServer": "El archivo es demasiado grande para el servidor.",
                "sessionExpired": "Tu sesión expiró. Iniciá sesión de nuevo.",
                "saveFailed": "No se pudo guardar la descripción de puesto. Intentá de nuevo."
            }
        },
        "cvRewrite": {
            "ariaLabel": "Análisis completo",
            "title": "Análisis completo",
            "subtitle": "Combiná un CV analizado con un puesto decodificado y tus notas de voz para generar un análisis completo.",
            "newRewriteLabel": "NUEVO ANÁLISIS COMPLETO",
            "loadingOptionsAriaLabel": "Cargando opciones",
            "cvFieldLabel": "CV",
            "noCvsOption": "Todavía no hay CVs analizados",
            "selectCvOption": "Seleccioná un CV…",
            "jdFieldLabel": "Descripción del puesto",
            "noJdsOption": "Todavía no hay puestos decodificados",
            "selectJdOption": "Seleccioná un puesto…",
            "noCvsHint": "Primero subí y analizá un CV (estado Analizado).",
            "noJdsHint": "Agregá una descripción de puesto y esperá a que quede Decodificado.",
            "upsell": "Disponible desde el plan Core",
            "quotaExhausted": "Usaste todos los análisis completos de este período. Mejorá el plan o esperá al siguiente período.",
            "starting": "Iniciando…",
            "submitCta": "Correr análisis completo para este puesto",
            "artifactsLabel": "ANÁLISIS COMPLETOS",
            "selectCvHint": "Seleccioná un CV para ver sus análisis completos.",
            "loadingArtifactsAriaLabel": "Cargando análisis completos",
            "noArtifactsTitle": "Todavía no hay análisis completos para este CV.",
            "noArtifactsHint": "Elegí un puesto decodificado e iniciá tu primer análisis completo.",
            "itemName": "Análisis completo #{{id}}",
            "jdFallback": "Puesto #{{id}}",
            "statusAriaLabel": "Estado: {{status}}",
            "downloadError": "No se pudo descargar el PDF. Intentá de nuevo.",
            "downloading": "Descargando…",
            "downloadPdf": "Descargar PDF",
            "detailLabel": "ANÁLISIS COMPLETO",
            "hide": "Ocultar",
            "hideAriaLabel": "Ocultar detalle del análisis completo",
            "noSelectionTitle": "No hay ningún análisis completo seleccionado.",
            "loadingDetailAriaLabel": "Cargando análisis completo",
            "statusCompletedAriaLabel": "Estado: Completado",
            "payloadPending": "El análisis completo terminó pero el resultado todavía no está disponible.",
            "unavailable": "Análisis completo no disponible",
            "status": {
                "pending": "Pendiente",
                "processing": "Corriendo análisis completo…",
                "completed": "Completado",
                "failed": "Falló"
            },
            "detailHints": {
                "pending": "El análisis completo está en cola. El detalle va a estar disponible cuando el estado sea Completado.",
                "processing": "El análisis completo está en curso. Volvé en un momento…",
                "failed": "Este análisis completo falló. Iniciá uno nuevo o elegí otro.",
                "none": "Seleccioná un análisis completo de la lista para ver el detalle."
            },
            "section": {
                "summary": "Resumen",
                "atsScore": "Puntaje ATS",
                "matchScore": "Puntaje de compatibilidad",
                "matchedRequirements": "Requisitos que coinciden",
                "missingRequirements": "Requisitos faltantes",
                "missingKeywords": "Palabras clave faltantes",
                "overusedKeywords": "Palabras clave sobreutilizadas",
                "keywordSuggestions": "Sugerencias de palabras clave",
                "rewrittenSections": "Secciones reescritas",
                "intentLabel": "Intención:",
                "defendedEvidence": "Evidencia respaldada"
            },
            "errors": {
                "loadOptionsFailed": "No se pudieron cargar los CVs y las descripciones de puesto. Actualizá la página.",
                "jdNotParsed": "La descripción de puesto debe estar Decodificada antes del análisis completo. Revisá tu selección.",
                "notFound": "No se encontró el CV o la descripción de puesto.",
                "sessionExpired": "Tu sesión expiró. Iniciá sesión de nuevo.",
                "artifactFailed": "No se pudo terminar el análisis completo. Intentá de nuevo.",
                "startFailed": "No se pudo iniciar el análisis completo. Intentá de nuevo.",
                "detailLoadFailed": "No se pudo cargar el detalle del análisis completo. Intentá de nuevo.",
                "timeout": "El análisis completo está tardando más de lo esperado. Actualizá esta página en unos minutos para ver si terminó."
            },
            "startedTitle": "Análisis completo iniciado",
            "startedBody": "Esto puede tardar unos minutos. Podés salir de esta página — seguimos trabajando.",
            "startedDismiss": "Entendido"
        },
        "realityCheck": {
            "ariaLabel": "Reality Check Report",
            "title": "Reality Check Report",
            "subtitle": "Evaluación honesta de encaje, planes de acción de 30–45 días y secciones de CV compatibles con ATS.",
            "readyLabel": "LISTO PARA GENERAR",
            "loadingArtifactsAriaLabel": "Cargando análisis completos",
            "noArtifactsTitle": "Todavía no hay análisis completos.",
            "noArtifactsHint": "Terminá un análisis completo antes de generar un Reality Check.",
            "artifactTitle": "Análisis completo #{{id}}",
            "resumeLabel": "CV {{id}}",
            "jdLabel": "Puesto {{id}}",
            "starting": "Iniciando…",
            "generating": "Generando…",
            "upsell": "Disponible desde el plan Core",
            "generateCta": "Generar informe",
            "viewCta": "Ver informe",
            "regenerateCta": "Regenerar",
            "errors": {
                "loadDataFailed": "No se pudieron cargar los datos del Reality Check. Actualizá la página.",
                "loadResumesFailed": "No se pudieron cargar tus CVs. Actualizá la página.",
                "artifactNotReady": "El análisis completo todavía no está listo. Terminalo primero.",
                "sessionExpired": "Tu sesión expiró. Iniciá sesión de nuevo.",
                "generateFailed": "No se pudo generar el informe. Intentá de nuevo."
            },
            "detail": {
                "ariaLabel": "Detalle del Reality Check Report",
                "yourReportLabel": "TU INFORME",
                "hide": "Ocultar",
                "loadingReportAriaLabel": "Cargando informe",
                "reportId": "Informe #{{id}}",
                "statusAriaLabel": "Estado: {{status}}",
                "atsScore": "Puntaje ATS",
                "matchScore": "Puntaje de compatibilidad",
                "pollingHint": "La IA está armando tu reality check. Normalmente tarda menos de un minuto…",
                "genericFailure": "Falló la generación del informe. Intentá de nuevo.",
                "filteredBanner": "Estás viendo la vista reducida (plan Core): diagnóstico y quick wins solamente. Actualizá a Pro para el análisis completo de tus hipótesis y el roadmap entero.",
                "section": {
                    "realDiagnosis": "Diagnóstico real",
                    "supportingEvidence": "Evidencia de respaldo",
                    "strengthsToAcknowledge": "Fortalezas a reconocer",
                    "roadmap": "Roadmap",
                    "pathA": "Camino A — Victorias rápidas",
                    "pathB": "Camino B — Cerrar la brecha",
                    "pathC": "Camino C — Giro estratégico",
                    "expectedOutcome": "Resultado esperado:",
                    "yourHypotheses": "Tus hipótesis, verificadas",
                    "evidenceLabel": "Evidencia:",
                    "implicationsForSearch": "Implicancias para tu búsqueda",
                    "interventionNeeded": "Intervención necesaria:",
                    "realisticTimeline": "Cronograma realista:",
                    "realisticRoles": "Puestos realistas a los que postularte",
                    "rolesToAvoid": "Puestos a evitar (y por qué)"
                },
                "status": {
                    "pending": "Pendiente",
                    "processing": "Generando…",
                    "completed": "Listo",
                    "failed": "Falló"
                },
                "validity": {
                    "valid": "Válida",
                    "partiallyValid": "Parcialmente válida",
                    "excuse": "Excusa",
                    "notAddressed": "No abordada"
                },
                "intervention": {
                    "repositioning": "Reposicionamiento",
                    "reconstruction": "Reconstrucción",
                    "pivot": "Giro",
                    "minorPolish": "Ajuste menor"
                },
                "errors": {
                    "invalidId": "ID de informe inválido.",
                    "loadFailed": "No se pudo cargar el informe. Intentá de nuevo."
                }
            }
        },
        "jobMatches": {
            "ariaLabel": "Coincidencias de empleo",
            "title": "Coincidencias de empleo",
            "subtitle": "Cómo puntúa tu CV contra cada descripción de puesto para la que corriste un análisis completo.",
            "loadingAriaLabel": "Cargando coincidencias de empleo",
            "emptyTitle": "Todavía no hay coincidencias de empleo.",
            "emptyHint": "Corré un análisis completo contra una descripción de puesto para ver acá tu puntaje de compatibilidad.",
            "statusAriaLabel": "Estado: {{status}}",
            "status": {
                "pending": "Pendiente",
                "processing": "Calculando…",
                "completed": "Calculado",
                "failed": "Falló"
            },
            "errors": {
                "loadMatchesFailed": "No se pudieron cargar las coincidencias de empleo. Actualizá la página.",
                "loadResumesFailed": "No se pudieron cargar tus CVs. Actualizá la página."
            }
        },
        "statsRow": {
            "ariaLabel": "Estadísticas de CV"
        },
        "resultsOverview": {
            "ariaLabel": "Últimos resultados del CV",
            "detailedHeading": "Puntajes detallados",
            "errorsHeading": "Errores detectados",
            "fixedBadge": "Corregido en el CV",
            "seeAllErrors": "Ver todos los errores",
            "noErrors": "No se detectaron errores en este CV.",
            "upsell": "Desbloqueá el detalle completo de errores con Core",
            "scoresExplainer": "¿Cómo se calculan estos puntajes?",
            "downloadCta": "Descargar CV optimizado",
            "downloadHint": "Disponible cuando generes un análisis completo desde Mis CVs.",
            "downloadFailed": "No pudimos descargar tu CV. Intentá de nuevo."
        },
        "matchBoard": {
            "ariaLabel": "Plan, matches y postulaciones",
            "heading": "Te ayudamos a encontrar tu match perfecto",
            "jobsHeading": "Empleos que matchean con vos",
            "seeMoreMatches": "Ver más roles en Seguimiento de postulaciones →",
            "basedOnCv": "Según tu CV",
            "careerPathBadge": "Career path",
            "jobsLoading": "Cargando roles sugeridos…",
            "jobsLoadFailed": "No se pudieron cargar los roles sugeridos. Probá de nuevo más tarde.",
            "jobsEmptyTitle": "Corré un análisis completo para ver roles que matchean",
            "jobsEmptyBody": "Corré un análisis completo en Mis CVs primero. Usamos ese resultado para sugerirte otros empleos a los que podés matchear y postularte.",
            "jobsEmptyCta": "Ir a Mis CVs →",
            "freeChecklistAria": "Funciones según el plan",
            "availableOn": "Disponible en {{plan}}",
            "freeChecklistCta": "Ver planes y mejorar →"
        },
        "scoreRing": {
            "ariaLabel": "Puntaje general {{score}} de 100",
            "outOf": "/100"
        },
        "myAnalysis": {
            "ariaLabel": "Mi análisis",
            "loadingAriaLabel": "Cargando análisis",
            "yourScore": "Tu puntaje",
            "downloadOptimizedCv": "Descargar CV optimizado",
            "optimizedCvHint": "Disponible después de un análisis completo en Mis CVs.",
            "errorsHeading": "Errores detectados",
            "fixInCv": "Corregirlo en el CV",
            "upgradeToPro": "Pasate a PRO",
            "seePlans": "Ver planes →",
            "fixedBadge": "Corregido en el CV",
            "noErrors": "No se detectaron errores en este CV.",
            "upsell": "Desbloqueá el detalle completo de errores con Core",
            "detailedHeading": "Puntajes detallados",
            "compareHeading": "Comparativa antes y después",
            "afterLabel": "Después",
            "beforeLabel": "Antes",
            "improvedPoints": "Puntos mejorados",
            "skillsGapHeading": "ANÁLISIS DE BRECHA DE SKILLS",
            "skillsGapFallback": "Corré un análisis completo para ver cómo se comparan tus skills con los roles que buscás.",
            "downloadAnalysis": "Descargar análisis",
            "optimizedScoreLabel": "Optimizado",
            "optimizedScoreAriaLabel": "Puntaje del CV optimizado",
            "rewritePreview": {
                "title": "Vista rápida del análisis",
                "hint": "Una vista breve de tu último análisis completo. Las dos descargas quedan apagadas hasta que corras un análisis completo en Mis CVs. Descargar análisis exporta el resultado completo. Descargar CV optimizado exporta el CV en formato Harvard.",
                "analysisHeading": "Último análisis",
                "rewriteHeading": "Último análisis completo",
                "scoreLabel": "Puntaje",
                "atsLabel": "ATS",
                "matchLabel": "Match",
                "empty": "Todavía no hay un análisis completo. Corré un análisis completo en Mis CVs.",
                "ctaHint": "Disponible después de un análisis completo en Mis CVs.",
                "errors": {
                    "missingInputs": "Subí un CV y agregá una descripción de puesto primero.",
                    "rewriteFailed": "No se pudo completar el análisis. Intentá de nuevo.",
                    "timeout": "El análisis completo está demorando más de lo esperado. Revisá Mis CVs en un momento.",
                    "downloadFailed": "La descarga falló. Intentá de nuevo.",
                    "optimizedCvMissing": "Este análisis completo se guardó antes de los CV optimizados. Corré un análisis completo nuevo para generar el CV Harvard."
                }
            },
            "otherRolesTitle": "Otros roles que podrían encajarte",
            "otherRolesEmptyTitle": "No hay career paths para mostrar por el momento.",
            "otherRolesEmptyHint": "Corré un análisis completo en Mis CVs para generar sugerencias de career paths para tu perfil.",
            "otherRolesEmptyCta": "Ir a Mis CVs →",
            "otherRolesLoading": "Cargando roles sugeridos…",
            "otherRolesLoadFailed": "No se pudieron cargar los roles sugeridos. Intentá más tarde.",
            "careerPathBadge": "Career path",
            "matchBasedOnCv": "SEGÚN TU CV",
            "roleFitTitle": "Ajuste al rol",
            "emptyState": {
                "title": "Aún no hay análisis",
                "body": "Los puntajes se quedan en 0 hasta que subas un CV. Súbelo en Mis CVs para desbloquear tu análisis.",
                "cta": "Subir un CV →"
            }
        },
        "scoreSection": {
            "ariaLabel": "Vista previa del puntaje del CV",
            "frontAlt": "CV optimizado",
            "hint": "ⓘ ¿Cómo se calculan estos puntajes?"
        },
        "detailedScores": {
            "heading": "Puntajes detallados",
            "notAvailable": "N/D"
        },
        "errorsDetected": {
            "heading": "Errores detectados",
            "fixedBadge": "Corregido en el CV",
            "seeAllLink": "Ver todos los errores →"
        },
        "sevenDayPlan": {
            "ariaLabel": "Plan de 7 días",
            "heading": "Plan de 7 días",
            "onDay": "¡Estás en tu día {{day}}!",
            "progressMeta": "{{progress}} % completado - quedan {{days}} días",
            "progressText": "{{progress}}% completado · quedan 4 días",
            "stepAriaLabel": "Paso {{step}}",
            "completedAriaLabel": "Completado",
            "seeFullPlanLink": "Ver plan completo →",
            "lockedBody": "El plan de 7 días está disponible en {{plan}} y superior.",
            "lockedCta": "Ver planes y mejorar →",
            "completedHeading": "Completado",
            "nextStepsHeading": "Próximos pasos",
            "dayLabel": "Día",
            "todayBadge": "HOY",
            "todayAriaLabel": "Detalle del día {{day}}",
            "sectionATitle": "Empleos que matchean con tu CV",
            "sectionADesc": "Vacantes encontradas en la web para el CV optimizado en tu último análisis completo.",
            "sectionBTitle": "Usá tu CV optimizado",
            "sectionBDesc": "Descargá tu último análisis completo o revisalo antes de postularte.",
            "sectionCTitle": "Actualizá tu Application Tracker",
            "sectionCDesc": "Registrá cada postulación para hacer seguimiento a tiempo.",
            "linkedin": "LinkedIn",
            "otherPlatform": "Otra plataforma",
            "linkedinOffer": "Oferta LinkedIn",
            "otherOffer": "Otra oferta",
            "matchLabel": "{{score}}% match",
            "apply": "Aplicar",
            "moreLinkedin": "Ir a LinkedIn para buscar más >",
            "moreOther": "Ir a Job Matches para buscar más >",
            "downloadCv": "Descargar CV optimizado",
            "reviewCv": "Revisar nuevo CV",
            "or": "o",
            "goToTracker": "Ir al Application Tracker >",
            "day2Companies": {
                "heading": "Empresas top con empleos que coinciden con tu CV",
                "description": "Clasificadas a partir de las vacantes del Job Tracker para tu CV optimizado. Se guarda una vez en este plan — refrescar no vuelve a calcular.",
                "loading": "Cargando empresas top…",
                "loadFailed": "No se pudieron cargar las empresas top.",
                "empty": "Aún no hay empleos coincidentes. Ejecuta un análisis completo desde Mis CVs para que Job Tracker encuentre vacantes y vuelve al Día 2.",
                "jobCount": "{{count}} vacantes abiertas",
                "goToJobTracker": "Ver empleos en Job Tracker >"
            },
            "whyHeading": "Por qué importa",
            "whyP1": "Un plan de 7 días enfocado convierte la búsqueda dispersa en progreso diario: CV, outreach y entrevistas trabajando juntos.",
            "whyP2": "Completar cada paso se acumula: mejores postulaciones hoy significan entrevistas y ofertas más fuertes la próxima semana.",
            "days": {
                "d1": {
                    "title": "Optimizar CV + Actualizar LinkedIn",
                    "todayHint": "Hoy - Optimiza tu CV",
                    "sectionATitle": "Postulate a 5-10 roles que coincidan con tu CV",
                    "sectionADesc": "Abre roles en LinkedIn y otras plataformas usando tu CV optimizado. (Placeholder temporal - reemplazar con el copy final del día.)",
                    "sectionBTitle": "Usa tu CV optimizado",
                    "sectionBDesc": "Descarga el CV analizado por HireFit o revisalo antes de postularte. (Placeholder temporal.)",
                    "sectionCTitle": "Actualiza tu Application Tracker",
                    "sectionCDesc": "Lleva el control de cada postulación para hacer seguimiento a tiempo. (Placeholder temporal.)",
                    "tableTaskHeading": "Tarea",
                    "tableMinHeading": "Mínimo (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "d1DownloadCv": "Descarga tu CV",
                    "d1DownloadCvMin": "Descarga tu CV optimizado en {idioma_vacantes}",
                    "d1DownloadCvIdeal": "Igual + versión en el otro idioma si aplicas a ambos mercados",
                    "d1UpdateLinkedin": "Actualiza LinkedIn",
                    "d1UpdateLinkedinMin": "Cambia tu headline a: \"{headline_sugerido}\"",
                    "d1UpdateLinkedinIdeal": "Headline + sección Acerca de + tus últimas 2 experiencias iguales a tu CV",
                    "d1OpenToWork": "Open to Work",
                    "d1OpenToWorkMin": "{instruccion_open_to_work}",
                    "d1OpenToWorkIdeal": "Igual + agrega los 3 títulos exactos que buscas",
                    "d1BlockTime": "Bloquea tu tiempo",
                    "d1BlockTimeMin": "Agenda en tu calendario tus bloques de búsqueda de esta semana",
                    "d1BlockTimeIdeal": "Igual"
                },
                "d2": {
                    "title": "Definir objetivo + guardar 10 empleos",
                    "todayHint": "Hoy - Empresas top que coinciden con tu CV",
                    "sectionATitle": "Postulate a 5-10 roles que coincidan con tu CV",
                    "sectionADesc": "Abre roles en LinkedIn y otras plataformas usando tu CV optimizado. (Placeholder temporal - reemplazar con el copy final del día.)",
                    "sectionBTitle": "Usa tu CV optimizado",
                    "sectionBDesc": "Descarga el CV analizado por HireFit o revisalo antes de postularte. (Placeholder temporal.)",
                    "sectionCTitle": "Actualiza tu Application Tracker",
                    "sectionCDesc": "Lleva el control de cada postulación para hacer seguimiento a tiempo. (Placeholder temporal.)"
                },
                "d3": {
                    "title": "Adapta tu CV, aplica y escribe al reclutador",
                    "todayHint": "Hoy — Adapta, aplica y escribe",
                    "sectionATitle": "Adapta tu CV",
                    "sectionADesc": "Para cada vacante \"aplicar\": ajusta tu resumen y 2-3 bullets con las palabras de la descripción del puesto, sin inventar nada",
                    "sectionBTitle": "Aplica",
                    "sectionBDesc": "4 aplicaciones",
                    "sectionCTitle": "Mensaje al reclutador",
                    "sectionCDesc": "Si encuentras al reclutador, envía el mensaje T1 el mismo día",
                    "tableTaskHeading": "Tarea",
                    "tableMinHeading": "Mínimo (45-60 min)",
                    "adaptCv": "Adapta tu CV",
                    "adaptCvMin": "Para cada vacante \"aplicar\": ajusta tu resumen y 2-3 bullets con las palabras de la descripción del puesto, sin inventar nada",
                    "apply": "Aplica",
                    "applyMin": "4 aplicaciones",
                    "messageRecruiter": "Mensaje al reclutador",
                    "messageRecruiterMin": "Si encuentras al reclutador, envía el mensaje T1 el mismo día"
                },
                "d4": {
                    "title": "Conectar con 10 recruiters en LinkedIn",
                    "todayHint": "Hoy - Conecta con recruiters",
                    "sectionATitle": "Red cercana",
                    "sectionADesc": "Envía T2 a 5 personas que ya te conocen (ex-compañeros, amigos del sector)",
                    "sectionBTitle": "Reclutadores",
                    "sectionBDesc": "Envía T3 a 3 reclutadores de tus empresas target",
                    "sectionCTitle": "Referidos",
                    "sectionCDesc": "Pide 1 referido (T4) para tu mejor vacante",
                    "tableTaskHeading": "Tarea",
                    "tableMinHeading": "Mínimo (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "closeNetwork": "Red cercana",
                    "closeNetworkMin": "Envía T2 a 5 personas que ya te conocen (ex-compañeros, amigos del sector)",
                    "closeNetworkIdeal": "Envía T2 a 20 personas",
                    "recruiters": "Reclutadores",
                    "recruitersMin": "Envía T3 a 3 reclutadores de tus empresas target",
                    "recruitersIdeal": "Envía T3 a 10",
                    "referrals": "Referidos",
                    "referralsMin": "Pide 1 referido (T4) para tu mejor vacante",
                    "referralsIdeal": "Pide 3"
                },
                "d5": {
                    "title": "Preparación de entrevistas (método STAR)",
                    "todayHint": "Hoy - Preparate para entrevistas",
                    "tableTaskHeading": "Tarea",
                    "tableMinHeading": "Mínimo (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "pitch": "Tu pitch",
                    "pitchMin": "Escribe y graba tu \"Cuéntame sobre ti\" de 60 segundos. Base: \"{pitch_base}\"",
                    "pitchIdeal": "Igual + grábalo 3 veces y quédate con la mejor",
                    "starStories": "Historias STAR",
                    "starStoriesMin": "Prepara 2 historias con tus logros: {logros_para_star}",
                    "starStoriesIdeal": "Prepara 4",
                    "probableQuestions": "Preguntas probables",
                    "probableQuestionsMin": "Practica en voz alta: {3_preguntas_probables}",
                    "probableQuestionsIdeal": "Igual + Mock Interview de HireFit (Premium)",
                    "gapTask": "{tarea_gap}",
                    "gapTaskMin": "{tarea_gap_minimo}",
                    "gapTaskIdeal": "{tarea_gap_ideal}"
                },
                "d6": {
                    "title": "Seguimiento de postulaciones",
                    "todayHint": "Hoy - Haz seguimiento",
                    "tableTaskHeading": "Tarea",
                    "tableMinHeading": "Mínimo (45-60 min)",
                    "d6FollowUps": "Follow-ups",
                    "d6FollowUpsMin": "Envía T5 a aplicaciones con 5-7 días hábiles sin respuesta. Máximo 2 por vacante.",
                    "d6ThankYous": "Thank-yous",
                    "d6ThankYousMin": "Envía T6 dentro de 24 h después de cada entrevista.",
                    "d6RespondNetwork": "Responde a tu red",
                    "d6RespondNetworkMin": "Contesta a quien te respondió y agenda llamadas.",
                    "d6LogEverything": "Registra todo",
                    "d6LogEverythingMin": "Actualiza el estado de cada vacante: aplicada, respondió, entrevista, rechazo."
                },
                "d7": {
                    "title": "Revisar progreso + planear la próxima semana",
                    "todayHint": "Hoy - Revisa tu semana",
                    "sectionATitle": "Postulate a 5-10 roles que coincidan con tu CV",
                    "sectionADesc": "Abre roles en LinkedIn y otras plataformas usando tu CV optimizado. (Placeholder temporal - reemplazar con el copy final del día.)",
                    "sectionBTitle": "Usa tu CV optimizado",
                    "sectionBDesc": "Descarga el CV analizado por HireFit o revisalo antes de postularte. (Placeholder temporal.)",
                    "sectionCTitle": "Actualiza tu Application Tracker",
                    "sectionCDesc": "Lleva el control de cada postulación para hacer seguimiento a tiempo. (Placeholder temporal.)",
                    "metricsHeading": "Tu semana en números",
                    "tableMetricHeading": "Métrica",
                    "tableLastEntryHeading": "Último número registrado",
                    "tableNumberHeading": "Tu número",
                    "metrics": {
                        "savedVacancies": "Vacantes guardadas",
                        "applicationsSent": "Aplicaciones enviadas",
                        "messagesSent": "Mensajes a personas enviados",
                        "positiveResponses": "Respuestas positivas (a aplicaciones o mensajes)",
                        "hrScreenings": "Llamadas con RRHH / screenings",
                        "teamInterviews": "Entrevistas con el área",
                        "nextRound": "Pasaste a la siguiente ronda"
                    }
                }
            },
            "offers": {
                "o1Title": "Customer Service Trainer",
                "o1Meta": "Remoto - Tiempo completo",
                "o2Title": "Learning & Development Specialist",
                "o2Meta": "Híbrido - Tiempo completo",
                "o3Title": "Client Success Manager",
                "o3Meta": "Remoto - Tiempo completo",
                "o4Title": "Training Coordinator",
                "o4Meta": "Presencial - Tiempo completo",
                "o5Title": "Instructional Designer",
                "o5Meta": "Remoto - Contrato",
                "o6Title": "People Experience Associate",
                "o6Meta": "Híbrido - Tiempo completo"
            },
            "loading": "Cargando tu plan de 7 días…",
            "loadFailed": "No se pudo cargar el plan. Intentá de nuevo.",
            "noResume": "Subí un CV para generar tu plan de 7 días.",
            "goUploadCv": "Ir a Mis CVs →",
            "completeCta": "Completar",
            "completing": "Guardando…",
            "completeFailed": "No se pudo completar el día. Intentá de nuevo.",
            "completedOn": "Completado el {{date}}",
            "nextStepLabel": "Próximo paso",
            "upcomingLabel": "Próximamente",
            "noneCompletedYet": "Aún no completaste ningún día.",
            "allDaysDone": "¡Completaste los 7 días!",
            "allCompleteTitle": "¡Completaste tu plan de 7 días!",
            "dayDetailHeading": "DÍA {{day}} - HOY - {{title}}",
            "tasksHeading": "Lista de hoy",
            "tasksIncompleteHint": "Marcá todas las tareas requeridas para habilitar Completar.",
            "interviewPrepCta": "Ir a Preparación de entrevistas",
            "jobTrackerCta": "Ir a Job Tracker",
            "linkedinCta": "Ir a LinkedIn",
            "premiumBadge": "PREMIUM",
            "repeatCta": "Repetir el proceso",
            "resetting": "Reiniciando…",
            "resetFailed": "No se pudo reiniciar el plan. Intentá de nuevo.",
            "metricsIncompleteHint": "Ingresá un número (0 o más) en cada métrica para habilitar Completar.",
            "metricsSaveFailed": "No se pudo guardar esa métrica. Intentá de nuevo.",
            "taskToggleFailed": "No se pudo actualizar esa tarea. Intentá de nuevo."
        },
        "applicationTracker": {
            "heading": "Seguimiento de postulaciones",
            "lockedBody": "El Seguimiento de aplicaciones está disponible en {{plan}} o superior. Mejorá tu plan para registrar postulaciones, estado y próximos pasos en un solo lugar.",
            "lockedCta": "Ver planes y mejorar →",
            "emptyBody": "Tu plan incluye el Seguimiento de aplicaciones. Empieza a registrar postulaciones para organizar seguimientos y entrevistas.",
            "emptyCta": "Abrir Job Tracker →",
            "loading": "Cargando preguntas de entrevista...",
            "loadFailed": "No se pudieron cargar las aplicaciones. Inténtalo desde Job Tracker.",
            "tableAriaLabel": "Postulaciones laborales",
            "actionColumnLabel": "Acción",
            "columns": {
                "company": "Empresa",
                "role": "Puesto",
                "date": "Fecha",
                "status": "Estado",
                "nextStep": "Próximo paso"
            },
            "seeApplicationLink": "Ver postulación",
            "viewAllLink": "Ver todas las postulaciones →"
        },
        "jobTracker": {
            "ariaLabel": "Job Tracker",
            "heading": "Application Tracker",
            "tableAriaLabel": "Postulaciones laborales",
            "actionColumnLabel": "Acción",
            "columns": {
                "company": "Empresa",
                "role": "Puesto",
                "date": "Fecha",
                "status": "Estado",
                "nextStep": "Próximo paso"
            },
            "status": {
                "APPLIED": "Aplicado",
                "IN_INTERVIEW": "En entrevista",
                "PENDING": "Pendiente",
                "REJECTED": "Rechazado"
            },
            "nextSteps": {
                "FOLLOW_UP_ON_MY_END": "Seguimiento de mi parte",
                "WAITING_FOR_UPDATE": "Esperando actualización",
                "PENDING_DATA_ON_MY_END": "Pendiente de datos de mi parte"
            },
            "addApplication": "Agregar nueva postulación",
            "saveEdits": "Guardar",
            "matchedJobs": {
                "title": "Empleos que matchean con tu CV",
                "description": "Vacantes encontradas en la web para el CV optimizado en tu último análisis completo, filtradas por tu ubicación.",
                "loading": "Buscando empleos que matcheen…",
                "loadFailed": "No se pudieron cargar los empleos.",
                "empty": "Corré un análisis completo en Mis CVs para ver empleos que matcheen con tu CV optimizado.",
                "emptyAfterAnalysis": "No se encontraron vacantes abiertas para este CV. Buscar empleos queda deshabilitado hasta que corras un análisis nuevo con otro CV.",
                "alreadySaved": "Los empleos que matchean para este análisis ya están guardados. Buscar empleos queda deshabilitado hasta que corras un análisis nuevo con otro CV.",
                "work": {
                    "REMOTE": "Remoto",
                    "HYBRID": "Híbrido",
                    "OFFICE": "Oficina"
                },
                "time": {
                    "FULL_TIME": "Tiempo completo",
                    "PART_TIME": "Medio tiempo"
                },
                "locationLabel": "Tu ubicación",
                "locationPlaceholder": "Ciudad y país, p. ej. San José, Costa Rica",
                "locationHelp": "Obligatoria. Los empleos se filtran a esta ubicación (no a nivel mundial).",
                "includeRemote": "También incluir empleos 100% remotos",
                "search": "Buscar empleos que matcheen",
                "searching": "Buscando…",
                "needLocation": "Ingresá tu ubicación arriba para encontrar empleos que coincidan con tu CV optimizado.",
                "searchFailed": "No se pudo buscar empleos. Inténtalo de nuevo.",
                "readyToSearch": "Ubicación guardada. Haz clic en “Buscar empleos que matcheen” para buscar con tu CV optimizado."
            },
            "notifications": {
                "heading": "Notificaciones",
                "intro": "Elegí cómo HireFit debe recordarte seguimientos, entrevistas y próximos pasos de tu búsqueda laboral.",
                "optInQuestion": "¿Querés recibir notificaciones y recordatorios?",
                "optInYes": "¡Sí, manteneme al día!",
                "optInNo": "No, prefiero no recibir recordatorios.",
                "channelQuestion": "¿Cómo te gustaría recibirlas?",
                "smsTitle": "Celular (SMS)",
                "smsDesc": "Vas a recibir mensajes en tu teléfono",
                "emailTitle": "Email",
                "emailDesc": "Recibí tus recordatorios en tu bandeja de entrada",
                "otherTitle": "Otra plataforma",
                "otherDesc": "Recibí recordatorios en otra app de mensajería",
                "otherPlaceholder": "Como Whatsapp, Telegram, Slack, etc",
                "save": "Guardar preferencias",
                "cancel": "Cancelar"
            },
            "delete": "Eliminar",
            "rowMenuAriaLabel": "Acciones de la postulación",
            "loading": "Cargando postulaciones…",
            "empty": "Aún no hay postulaciones. Agregá la primera.",
            "errors": {
                "loadFailed": "No se pudieron cargar las postulaciones. Intentá de nuevo.",
                "createFailed": "No se pudo crear la postulación. Intentá de nuevo.",
                "updateFailed": "No se pudieron guardar los cambios. Intentá de nuevo.",
                "deleteFailed": "No se pudo eliminar la postulación. Intentá de nuevo."
            }
        },
        "outreach": {
            "ariaLabel": "Mensajes de outreach",
            "title": "Mensajes de outreach",
            "subtitle": "Mensajes para un recruiter, escritos a partir de tu CV optimizado y la descripción del puesto.",
            "exclusivePrefix": "Exclusivo para planes",
            "planPro": "Pro",
            "exclusiveAnd": "y",
            "planPremium": "Premium",
            "exclusiveSuffix": "",
            "linkedinLabel": "Mensaje de LinkedIn",
            "emailLabel": "Email",
            "readyBadge": "Listo para copiar",
            "copyMessage": "Copiar mensaje",
            "copied": "¡Copiado!",
            "copyLinkedinAria": "Copiar mensaje de LinkedIn",
            "copyEmailAria": "Copiar mensaje de email",
            "subjectPrefix": "Asunto",
            "loading": "Escribiendo tus mensajes para el recruiter a partir del CV optimizado...",
            "emptyNoCv": "Subí un CV antes de generar mensajes de outreach.",
            "emptyNoRewrite": "Corré el análisis completo con tu CV y la descripción del puesto para generar un mensaje de LinkedIn y un email.",
            "errors": {
                "loadFailed": "No se pudieron escribir los mensajes de outreach. Intentá de nuevo."
            }
        },
        "linkedin": {
            "ariaLabel": "Optimización de LinkedIn",
            "title": "LinkedIn + Brand Card",
            "subtitle": "Optimizá tu perfil de LinkedIn y obtené una Brand Card profesional para destacar y crear una primera impresión fuerte.",
            "mockupTitle": "Mockup - Optimización de LinkedIn",
            "originalLabel": "Original:",
            "optimizedBadge": "Optimizado",
            "copyMessage": "Copiar mensaje",
            "copied": "¡Copiado!",
            "footnote": "Todas las sugerencias se generan automáticamente a partir de tu CV optimizado y el rol objetivo.",
            "loading": "Armando tu texto de LinkedIn a partir del CV optimizado...",
            "emptyNoCv": "Subí un CV y corré el análisis antes de optimizar tu perfil de LinkedIn.",
            "emptyNoRewrite": "Corré el análisis completo con tu CV y la descripción del puesto para generar headline, about y experiencia.",
            "experienceEmpty": "El CV optimizado no incluyó empleadores para reescribir.",
            "downloading": "Preparando...",
            "errors": {
                "loadFailed": "No se pudo armar el texto de LinkedIn. Intentá de nuevo.",
                "downloadFailed": "No se pudo preparar la descarga del banner. Intentá de nuevo."
            },
            "headline": {
                "label": "Headline",
                "original": "Customer Service Trainer | Team Lead",
                "optimized": "Customer Service Training Specialist | Boosting Team Performance +35% | Remote | LATAM",
                "copyAria": "Copiar headline optimizado"
            },
            "about": {
                "label": "About",
                "original": "I have experience in customer service and team training...",
                "optimizedP1": "Customer Service Training Specialist with 5+ years of experience leading high-performing support teams across LATAM.",
                "optimizedP2": "I design and deliver training programs that turn average teams into high-retention, high-performance units.",
                "optimizedLead": "Proven track record:",
                "bullet1": "+35% team retention",
                "bullet2": "−40% onboarding time",
                "bullet3": "Improved training efficiency across remote teams",
                "bullet4": "Available for remote opportunities in LATAM and US",
                "copyAria": "Copiar sección About optimizada"
            },
            "experience": {
                "label": "Experiencia",
                "original": "Customer Service Trainer — conducted team training.",
                "optimizedP1": "Designed and delivered training programs for customer service teams, focusing on performance, retention, and faster onboarding.",
                "optimizedP2": "Created performance tracking systems that helped managers identify skill gaps early and reduced onboarding time by 40%.",
                "copyAria": "Copiar experiencia optimizada",
                "skillsLabel": "Aptitudes"
            },
            "assets": {
                "ariaLabel": "Banners de LinkedIn y Brand Card",
                "title": "Mockup - LinkedIn Banner & Brand Card",
                "subtitle": "3 opciones de banner generadas automáticamente - nombre, rol objetivo, frase de posicionamiento y tu email",
                "banner1": "Banner Option 1",
                "banner2": "Banner Option 2",
                "banner3": "Banner Option 3",
                "download": "Download"
            }
        },
        "interviewPrep": {
            "ariaLabel": "Preparación de entrevistas",
            "hero": {
                "ariaLabel": "Banner de preparación para entrevistas simuladas",
                "eyebrow": "Entrevista simulada",
                "headingLine1": "Interview",
                "headingLine2": "PREPARATION",
                "copy": "Practicá preguntas típicas de entrevista en una entrevista simulada.",
                "speakerAria": "Reproducir consigna de la entrevista simulada"
            },
            "sections": {
                "personal": "Personales",
                "strengths": "Fortalezas, debilidades y motivaciones",
                "situational": "Situacionales y de comportamiento",
                "rrhh": "RRHH / Personal",
                "behavioral": "Conductuales",
                "technical": "Técnicas"
            },
            "answerLabel": "Tu respuesta a la pregunta {{number}}",
            "answerPlaceholder": "Escribí tu respuesta",
            "startRecording": "Grabar respuesta para la pregunta {{number}}",
            "stopRecording": "Detener grabación de la pregunta {{number}}",
            "footnote": "Tus respuestas son privadas: practicá todas las veces que quieras.",
            "questions": {
                "q1": {
                    "question": "¿Podés contarme sobre vos?",
                    "tip": "Conectá tu formación o tu recorrido profesional actual directamente con el trabajo que buscás."
                },
                "q2": {
                    "question": "¿Por qué deberíamos contratarte?",
                    "tip": "Matcheá tus habilidades específicas y logros previos con los objetivos exactos del aviso de trabajo."
                },
                "q3": {
                    "question": "¿Por qué querés trabajar acá?",
                    "tip": "Investigá la cultura y misión de la empresa para explicar cómo tus valores encajan con los suyos."
                },
                "q4": {
                    "question": "¿Cuáles son tus mayores fortalezas?",
                    "tip": "Elegí una fortaleza mencionada en el aviso y respaldala con un ejemplo breve."
                },
                "q5": {
                    "question": "¿Cuáles son tus debilidades?",
                    "tip": "Nombrá un área real de mejora y explicá los pasos concretos que estás dando para trabajarla."
                },
                "q6": {
                    "question": "¿Qué te motiva?",
                    "tip": "Compartí un ejemplo profesional donde resolver un problema o ayudar al equipo impulse tu trabajo."
                },
                "q7": {
                    "question": "Contame sobre una vez que enfrentaste un desafío.",
                    "tip": "Usá el método STAR (Situación, Tarea, Acción, Resultado) para contar una historia breve de cómo resolviste un problema laboral difícil."
                },
                "q8": {
                    "question": "¿Por qué te vas de tu trabajo actual?",
                    "tip": "Mantené un tono positivo enmarcando el cambio como un paso hacia nuevo crecimiento y responsabilidad."
                }
            },
            "loading": "Cargando preguntas de entrevista...",
            "emptyNoCv": "Sube un CV primero para obtener preguntas adaptadas a tu descripción del puesto.",
            "emptyNoQuestions": "Aún no se pudieron asignar preguntas. Agregá una descripción del puesto a tu CV e intentá de nuevo.",
            "errors": {
                "loadFailed": "No se pudieron cargar las preguntas de entrevista. Inténtalo de nuevo.",
                "saveFailed": "No se pudo guardar tu respuesta. Inténtalo de nuevo.",
                "emptyTypedAnswer": "Escribí una respuesta antes de guardar.",
                "feedbackFailed": "No se pudo generar la retroalimentación. Inténtalo de nuevo.",
                "resetFailed": "No se pudieron reiniciar tus respuestas. Inténtalo de nuevo."
            },
            "preferRecordingHint": "Consejo: grabar suele capturar más detalle que escribir.",
            "typeAnswerLabel": "O escribí tu respuesta",
            "typeAnswerPlaceholder": "Escribí tu respuesta aquí…",
            "saveTypedCta": "Guardar",
            "saving": "Guardando…",
            "resetCta": "Reiniciar respuestas",
            "resetting": "Reiniciando…",
            "feedback": {
                "ariaLabel": "Retroalimentación de preparación vs descripción del puesto",
                "title": "Retroalimentación vs descripción del puesto",
                "loading": "Comparando tus respuestas con la descripción del puesto…",
                "strengths": "Fortalezas",
                "improvements": "Puntos de mejora",
                "suggestions": "Sugerencias"
            }
        },
        "settings": {
            "eyebrow": "Configuración",
            "title": "Mi perfil",
            "loading": "Cargando tu perfil…",
            "loadError": "No se pudo cargar tu perfil. Intentá de nuevo más tarde.",
            "firstNameLabel": "Nombre",
            "lastNameLabel": "Apellido",
            "emailLabel": "Correo electrónico",
            "passwordLabel": "Nueva contraseña",
            "passwordPlaceholder": "Dejar en blanco para no cambiar",
            "currentPasswordLabel": "Contraseña actual",
            "currentPasswordPlaceholder": "Ingresá tu contraseña actual",
            "languageLabel": "Idioma",
            "languageEn": "Inglés",
            "languageEs": "Español",
            "submitDefault": "Guardar cambios",
            "submitLoading": "Guardando…",
            "successMessage": "Perfil actualizado correctamente.",
            "privacy": {
                "eyebrow": "Privacidad",
                "title": "Privacidad y datos",
                "intro": "Descargá una copia de tus datos de HireFit, o eliminá tu cuenta de forma permanente.",
                "exportTitle": "Descargar mis datos",
                "exportDescription": "Exportá un archivo JSON con tu perfil y los datos relacionados de HireFit.",
                "exportButton": "Descargar mis datos",
                "exportLoading": "Preparando descarga…",
                "exportError": "No se pudieron exportar tus datos. Intentá de nuevo.",
                "dangerTitle": "Zona de peligro",
                "dangerDescription": "Eliminar tu cuenta borra de forma permanente tus CVs, análisis, reportes y notas de voz. No hay período de gracia y no se puede deshacer.",
                "deleteButton": "Eliminar mi cuenta",
                "deleteModalTitle": "¿Eliminar tu cuenta?",
                "deleteModalBody": "Esto elimina de forma permanente tu cuenta y todos los datos asociados: CVs, análisis, reportes y notas de voz. No hay período de gracia y no podés deshacer esta acción.",
                "deleteConfirm": "Eliminar cuenta",
                "deleteLoading": "Eliminando…",
                "deleteCancel": "Cancelar",
                "deleteError": "No se pudo eliminar tu cuenta. Intentá de nuevo.",
                "deletePasswordRequired": "Ingresá tu contraseña actual para eliminar tu cuenta.",
                "closeAriaLabel": "Cerrar"
            },
            "errors": {
                "firstNameRequired": "El nombre es obligatorio.",
                "firstNameMax": "El nombre debe tener como máximo 100 caracteres.",
                "lastNameRequired": "El apellido es obligatorio.",
                "lastNameMax": "El apellido debe tener como máximo 100 caracteres.",
                "emailRequired": "El email es obligatorio.",
                "emailInvalid": "Ingresá un email válido.",
                "passwordTooShort": "La contraseña debe tener al menos 8 caracteres.",
                "currentPasswordRequired": "La contraseña actual es obligatoria para establecer una nueva.",
                "currentPasswordIncorrect": "La contraseña actual es incorrecta.",
                "emailConflict": "Ese email ya está en uso.",
                "validation": "Revisá tus datos e intentá de nuevo.",
                "forbidden": "No tenés permiso para actualizar este perfil.",
                "notFound": "Perfil no encontrado.",
                "submitFallback": "No se pudo actualizar tu perfil. Intentá de nuevo."
            }
        },
        "billing": {
            "eyebrow": "Facturación",
            "title": "Tu plan",
            "loading": "Cargando tu plan…",
            "errorMessage": "No se pudo cargar tu información de facturación. Intentá de nuevo más tarde.",
            "upgradeCta": "Actualizar",
            "currentPlanLabel": "Plan actual",
            "expiresLabel": "La licencia vence",
            "expiresOn": "Vence el {{date}}",
            "expiredOn": "Venció el {{date}}",
            "noExpiry": "Sin fecha de vencimiento registrada",
            "tierHeading": {
                "free": "Tu plan actual",
                "upgraded": "¡Felicitaciones!",
                "default": "Facturación"
            },
            "tierMessage": {
                "free": "Estás en el plan {{plan}}. Actualizá para desbloquear más análisis de CV, insights de carrera y funciones premium.",
                "core": "Tenés el plan {{plan}}. ¿Querés mejorar tu plan todavía más y desbloquear funciones adicionales de HireFit?",
                "pro": "Tenés el plan {{plan}}. ¿Querés mejorar tu plan todavía más y tener la experiencia completa de HireFit?",
                "premium": "Tenés el plan {{plan}} — el mejor plan disponible en HireFit. Disfrutá de acceso completo a todo lo que ofrecemos."
            }
        },
        "tierPlaceholder": {
            "billingCta": "Ver planes y actualizar",
            "fallbackTitle": "Función",
            "fallbackBody": "Esta función de HireFit está disponible en un plan superior.",
            "linkedinBody": "La optimización de LinkedIn y las revisiones orientadas a reclutadores están disponibles solo en Premium. La automatización completa sigue desplegándose aquí.",
            "interviewPrepBody": "Las mock interviews por notas de voz y la preparación de entrevistas están disponibles en Pro.",
            "outreachBody": "Los mensajes de outreach y los caminos de posicionamiento están disponibles en Pro."
        },
        "voiceNotes": {
            "heading": "Notas de voz",
            "subtitle": "Respondé las preguntas asignadas a tu CV. Grabá hasta {{seconds}} segundos por respuesta.",
            "noPending": "No hay preguntas de voz pendientes para este CV. Generá preguntas arriba cuando estén disponibles.",
            "pickQuestion": "Elegí una pregunta para responder",
            "answering": "Respondiendo:",
            "starting": "Iniciando...",
            "saving": "Guardando...",
            "startCta": "Iniciar grabación",
            "stopCta": "Detener grabación",
            "recordingLabel": "Grabando",
            "remainingLabel": "quedan {{seconds}}s",
            "remainingAriaLabel": "quedan {{seconds}} segundos",
            "errors": {
                "invalidSampleRate": "La frecuencia de muestreo debe ser un número positivo.",
                "startFailed": "No se pudo iniciar la sesión de streaming.",
                "noSpeechDetected": "No se detectó audio. Intentá grabar de nuevo.",
                "saveFailed": "No se pudo guardar la nota de voz.",
                "noQuestionSelected": "Seleccioná una pregunta pendiente antes de grabar.",
                "websocketUrlFailed": "No se pudo construir la URL del websocket.",
                "websocketError": "Error de conexión del websocket.",
                "microphoneUnavailable": "La API del micrófono no está disponible en este navegador.",
                "emptyTypedAnswer": "Escribí una respuesta antes de guardar.",
                "answerLocked": "Estas notas quedan bloqueadas cuando ya las respondiste todas."
            },
            "preferRecordingHint": "Consejo: grabar suele capturar más detalle que escribir.",
            "typeAnswerLabel": "O escribí tu respuesta",
            "typeAnswerPlaceholder": "Escribí tu respuesta aquí…",
            "saveTypedCta": "Guardar"
        },
        "voiceHistory": {
            "ariaLabel": "Notas de voz guardadas",
            "heading": "Notas de voz guardadas",
            "subtitle": "Preguntas asignadas y tus respuestas transcritas por cada CV.",
            "loading": "Cargando notas de voz...",
            "emptyHint": "Todavía no hay notas de voz. Generá preguntas en Mis CV.",
            "awaitingAnswer": "Esperando tu respuesta…",
            "rerecord": "Volver a grabar",
            "rerecordFailed": "No se pudo reabrir esta nota de voz. Intentá de nuevo.",
            "loadFailed": "No se pudieron cargar las notas de voz guardadas.",
            "status": {
                "pendingAnswer": "Pendiente de respuesta",
                "received": "Guardada",
                "processing": "Procesando",
                "processed": "Procesada",
                "failed": "Falló"
            }
        },
        "service": {
            "stats": {
                "cvsOptimized": "Análisis completos",
                "lastScore": "Último puntaje",
                "rolesAnalyzed": "Puestos analizados",
                "sevenDayPlan": "Plan de 7 días"
            },
            "statsLinks": {
                "seeDetailedScore": "Ver puntaje detallado →",
                "seeRolesYouFit": "Ver puestos que encajan →",
                "seeWhatsPending": "Ver qué falta →"
            },
            "scoreNames": {
                "atsCompatibility": "Compatibilidad ATS",
                "impactScore": "Puntaje de impacto",
                "clarity": "Claridad",
                "roleFit": "Compatibilidad con el puesto"
            },
            "errors": {
                "mockNoMetricsTitle": "Sin métricas cuantificables",
                "mockNoMetricsDesc": "4 de tus 6 bullet points no tienen resultados medibles.",
                "mockMissingJdTitle": "Faltan palabras clave del puesto",
                "mockMissingJdDesc": "Faltan 8 términos clave críticos para pasar el ATS",
                "missingKeywordsTitle": "Palabras clave faltantes",
                "missingKeywordsDesc": "Faltantes: {{keywords}}",
                "overusedKeywordsTitle": "Palabras clave sobreutilizadas",
                "overusedKeywordsDesc": "Sobreutilizadas: {{keywords}}",
                "analysisCompleteTitle": "Análisis completo"
            },
            "mockPlan": {
                "task1Title": "Optimizar CV + actualizar LinkedIn",
                "task1Subtitle": "Completado el 11 de abril",
                "task2Title": "Definir objetivo + guardar 10 puestos",
                "task2Subtitle": "Completado el 12 de abril",
                "task3Title": "Postularte a 5-10 puestos estratégicamente",
                "task3Subtitle": "Hoy - Usá tu CV optimizado",
                "task4Title": "Conectar con 10 reclutadores en LinkedIn",
                "task4Subtitle": "Próximo paso",
                "task5Title": "Preparación para entrevistas (método STAR)",
                "task5Subtitle": "Próximamente"
            },
            "mockApplications": {
                "followUpIn4Days": "Hacer seguimiento en 4 días",
                "none": "–"
            }
        },
        "emptyState": {
            "title": "Sube un CV para ver tus puntajes",
            "body": "Una cuenta nueva empieza en 0. Sube tu CV para analizarlo y mostrar datos reales de match.",
            "cta": "Ir a Mis CVs para subir →"
        }
    },
    "landing": {
        "helpImprove": {
            "ariaLabel": "Ayudanos a mejorar",
            "eyebrow": "Ayudanos a mejorar",
            "titleBefore": "Recibí una optimización de CV extra",
            "titleAccent": "gratis",
            "ratingLabel": "1. Calificación general",
            "ratingHint": "¿Cómo calificarías tu experiencia?",
            "ratingAria": "Calificación general",
            "starAria": "{{star}} de 5 estrellas",
            "ratingCaption": "Hacé clic en una estrella para calificar",
            "feedbackLabel": "2. Tu feedback",
            "feedbackHint": "¿Qué te gustó? ¿Qué podría estar mejor?",
            "improvementLabel": "3. ¿Notaste alguna mejora después de usar HireFit?",
            "improvementYes": "Sí",
            "improvementNo": "No",
            "improvementNotSure": "Todavía no estoy seguro",
            "emailLabel": "4. Correo electrónico",
            "emailHint": "¿A dónde te enviamos tu optimización de CV gratis?",
            "emailCaption": "Solo lo vamos a usar para enviarte la optimización gratis.",
            "submit": "Enviar y recibir mi optimización gratis →",
            "note": "Leemos cada respuesta. Tu feedback define cómo mejoramos HireFit.",
            "limit": "Disponible para usuarios Core, Pro y Premium. Te agregamos una optimización de CV extra a tu plan actual.",
            "thanks": "Gracias — recibimos tu feedback. Te vamos a escribir por tu optimización de CV gratis.",
            "errors": {
                "rating": "Elegí una calificación con estrellas.",
                "feedback": "Contanos qué te gustó o qué podría estar mejor.",
                "improvement": "Elegí si notaste mejoras.",
                "email": "Ingresá un correo electrónico válido."
            }
        },
        "hero": {
            "eyebrow": "Tu próximo empleo empieza aquí.",
            "title": "Sé HireFit.",
            "subtitle": "Hacemos que tu perfil sea imposible de ignorar.",
            "description1": "Tu CV compite contra otros 250, y el 75 % se descarta en menos de 6 segundos.",
            "description1Strong": "Sin llegar nunca a una persona.",
            "description2": "te dice exactamente por qué el tuyo está fallando, lo reescribe con el lenguaje al que los reclutadores realmente responden y te entrega un CV que consigue entrevistas en menos de 3 minutos. Dejá de enviar CV que nadie lee.",
            "cta": "Preparar mi CV para ser contratado",
            "featureAnalysis": "Análisis con IA al instante",
            "featureOptimization": "Optimización en 5 minutos",
            "featureKeywords": "Optimización de palabras clave"
        },
        "problem": {
            "eyebrow": "EL PROBLEMA",
            "titleBefore": "Tu CV no falla porque",
            "titleHighlight": "no estés calificado.",
            "subtitle": "Falla porque no estás hablando el lenguaje correcto para el mercado al que",
            "subtitleStrong": "apuntás.",
            "footnote": "Te ayudamos a evitar estos y muchos otros errores.",
            "stats": {
                "ats": {
                    "stat": "78 %",
                    "titleStart": "Se descartan antes de la",
                    "titleHighlight": "revisión humana",
                    "description": "El software ATS filtra automáticamente la mayoría de los CV antes de que un reclutador los vea."
                },
                "seconds": {
                    "stat": "6 s",
                    "titleStart": "",
                    "titleHighlight": "Es todo lo que tenés",
                    "description": "Cuando tu CV llega a un reclutador, tienes 6 segundos para comunicar tu valor. Un CV bien estructurado lo logra, pero la mayoría falla en esto."
                },
                "results": {
                    "stat": "3 de 4",
                    "titleStart": "CV enumeran responsabilidades,",
                    "titleHighlight": "no resultados",
                    "description": "Los reclutadores buscan logros medibles. Por ejemplo, «Gestioné un equipo» no consigue entrevistas. «Lideré un equipo de _ y aumenté la productividad un _ %» sí."
                }
            }
        },
        "ctaBanner": {
            "headlineBlue": "Dejá de perder",
            "headlineDark1": "entrevistas por",
            "headlineDark2": "errores simples en tu CV",
            "link": "¡Probá nuestra revisión de CV gratis!"
        },
        "banner": {
            "phrase1": "TU PRÓXIMO CAPÍTULO EMPIEZA AHORA.",
            "phrase2": "LA OPORTUNIDAD CORRECTA TE ENCONTRARÁ.",
            "phrase3": "EL PUESTO IDEAL ESTÁ AHÍ AFUERA."
        },
        "howItWorks": {
            "eyebrow": "TU SOLUCIÓN PARA",
            "title": "Ser contratado",
            "subtitle": "EN 4 PASOS SIMPLES",
            "tagline": "¡De subir tu perfil a recibir ofertas en minutos, no en meses!",
            "steps": {
                "upload": {
                    "title": "Subí tu perfil",
                    "description": "Subí tu CV o conectá tu perfil de LinkedIn en segundos."
                },
                "analysis": {
                    "title": "Análisis con IA",
                    "description": "Nuestra IA compara tu perfil con miles de candidatos exitosos."
                },
                "recommendations": {
                    "title": "Recibí recomendaciones",
                    "description": "Obtené retroalimentación detallada y accionable para mejorar la puntuación de tu perfil."
                },
                "apply": {
                    "title": "Descargá y postulate",
                    "description": "Exportá tu perfil optimizado y empezá a destacar ante los mejores reclutadores."
                }
            }
        },
        "howWeFixIt": {
            "eyebrow": "CÓMO LO SOLUCIONAMOS",
            "title1": "Con herramientas y análisis potentes que creamos para convertir",
            "title2": "tu perfil en un imán para reclutadores",
            "ats": {
                "title": "Optimización ATS",
                "description": "Superá los sistemas de seguimiento de candidatos con optimización de palabras clave y formato impulsada por IA."
            },
            "feedback": {
                "title": "Retroalimentación al instante",
                "description": "Análisis en tiempo real de tu perfil con sugerencias accionables para mejorar tu puntuación."
            },
            "privacy": {
                "title": "Privacidad primero",
                "description": "Tus datos se mantienen seguros y privados. Nunca compartimos tu información con terceros."
            },
            "growth": {
                "title": "Crecimiento profesional",
                "description": "Seguí la mejora de tu perfil a lo largo del tiempo y mide qué tan listo estás para el empleo."
            }
        },
        "impossibleCta": {
            "lead": "¿Estás listo para ser",
            "highlight": "imposible",
            "tail": "de ignorar?",
            "sub": "Sumate a otras personas que transformaron su carrera con",
            "checkResults": "Resultados al instante",
            "checkSecure": "Seguro y privado",
            "checkAts": "Resultado optimizado para ATS"
        },
        "pricing": {
            "yourPlanEyebrow": "TU PLAN",
            "youreOn": "Estás en",
            "bestPlanSubtitle": "Felicidades: ya tienes el mejor plan de HireFit.",
            "upgradeEyebrow": "MEJORA TU PLAN",
            "chooseYour": "Elegí tu",
            "nextPlan": "próximo plan",
            "upgradeSubtitle": "Estás en {{plan}}. Elegí un plan superior para desbloquear más.",
            "joinEyebrow": "SUMATE",
            "perfectPlan": "plan ideal",
            "joinSubtitle": "Pagos únicos. Sin suscripciones. Sin trucos.",
            "loading": "Cargando tus opciones de plan…",
            "currentPlanAria": "Plan actual",
            "congratulations": "¡Felicidades!",
            "bestPlanMessage": "Tienes el mejor plan que ofrece HireFit. Disfrutá del acceso completo a todas las funciones.",
            "startingCheckout": "Iniciando el pago…",
            "featuresAria": "Funciones de {{plan}}",
            "footnote": "Todos los planes incluyen manejo seguro de datos y protección de la privacidad.",
            "suffixForever": "/ para siempre",
            "suffixOneTime": "/ pago único",
            "access": "{{days}} días de acceso",
            "linkedin": "Optimización de LinkedIn",
            "quota": {
                "perLicense": "{{analyses}} análisis de CV + {{complete}} análisis completos (licencia de {{days}} días)",
                "perDay": "{{analyses}} análisis de CV + {{complete}} análisis completo por día ({{analysesTotal}} + {{completeTotal}} en {{days}} días)"
            },
            "errors": {
                "signIn": "Iniciá sesión para comprar un plan.",
                "serviceUnavailable": "El servicio de pagos no está disponible. Intentá más tarde.",
                "checkoutFailed": "No se pudo iniciar el pago."
            },
            "plans": {
                "free": {
                    "description": "Ideal para probar HireFit",
                    "cta": "Empezá gratis",
                    "f1": "Hire Probability Score",
                    "f2": "4 puntuaciones por dimensión (ATS, Impacto, Claridad, Ajuste al puesto)",
                    "f3": "Error principal detectado",
                    "f4": "CV optimizado completo",
                    "f5": "Plan de acción y outreach"
                },
                "core": {
                    "tier": "CONSIGUE ENTREVISTAS",
                    "description": "Tu CV, totalmente optimizado",
                    "cta": "Obtener Core",
                    "f1": "Todo lo de Free, resuelto",
                    "f2": "PDF compatible con ATS",
                    "f3": "Análisis de brechas de habilidades",
                    "f4": "Explicación de errores",
                    "f5": "Rutas profesionales y plan de 7 días"
                },
                "pro": {
                    "tier": "POSICIONAMIENTO ESTRATÉGICO",
                    "description": "El sistema completo para ser contratado",
                    "cta": "Empezá a optimizar",
                    "badge": "MÁS POPULAR",
                    "f1": "Todo lo de Core, más:",
                    "f2": "Rutas profesionales (3–4 puestos)",
                    "f3": "Plan de acción de 7 días",
                    "f4": "Mensajes de outreach en frío"
                },
                "premium": {
                    "tier": "POSICIONAMIENTO COMPLETO",
                    "description": "Todo lo que ve un reclutador, optimizado",
                    "cta": "Obtener Premium",
                    "f1": "Todo lo de Pro, más:",
                    "f2": "Reescritura del titular de LinkedIn",
                    "f3": "Reescritura de la sección Acerca de",
                    "f4": "Reescritura de la experiencia en LinkedIn",
                    "f5": "Banner de LinkedIn (2 opciones)",
                    "f6": "Puntuación de CV garantizada de 85+"
                }
            }
        }
    },
    "checkout": {
        "eyebrow": "Pago de HireFit",
        "opening": "Abriendo el pago seguro…",
        "sandboxNote": "Modo sandbox: usá solo tarjetas de prueba de Paddle.",
        "unavailable": "Pago no disponible",
        "backToPricing": "Volver a los precios",
        "success": "Pago realizado",
        "successMessage": "Tu licencia está activa. Redirigiendo a tu panel…",
        "activationIssue": "Problema de activación",
        "complete": "Completá tu compra",
        "completeMessage": "Si no apareció la ventana de Paddle, actualizá esta página o volvé a los precios e intentá de nuevo.",
        "errors": {
            "noSession": "No se encontró una sesión de pago. Elegí un plan en la sección de precios para continuar.",
            "loadFailed": "No se pudo cargar el pago de Paddle.",
            "failed": "El pago falló. Intentá de nuevo."
        }
    }
}
